import gql from "graphql-tag";

export const dealerIncentiveListQuery = gql`
  query dealerIncentiveList($orderBy: OrderBy, $page: Int, $perPage: Int) {
    dealerIncentiveList(orderBy: $orderBy, page: $page, first: $perPage) {
      data {
        id
        name
        createdAt
        startsAt
        endsAt
        status
      }
      paginatorInfo {
        currentPage
        perPage
        total
        lastPage
      }
    }
  }
`;
